import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { useFeatureFlags } from "@/hooks/use-feature-flags";
import type { FeatureFlagKey } from "@/lib/feature-flags";

interface FeatureFlagRouteProps {
  flagKey: FeatureFlagKey;
  children: ReactNode;
}

export function FeatureFlagRoute({ flagKey, children }: FeatureFlagRouteProps) {
  const { workspaceId, isLoading, isEnabled } = useFeatureFlags();

  if (!workspaceId) {
    return (
      <div className="space-y-4 max-w-md">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-24 w-full" />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="space-y-4 max-w-md">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-24 w-full" />
      </div>
    );
  }

  if (!isEnabled(flagKey)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
